{
  "label": "application",
  "name": "Name",
  "model": {
    "declination": "Model",
    "type": "Type"
  },
  "versionNumber": "Version number",
  "serialNumber": "Serial number",
  "terminalName": "Terminal name",
  "windowsUserAccount": "Windows user account",
  "sector": "Sector",
  "connectivity": "Connectivity",
  "certificate": "Certificate",
  "state": "State",
  "states": {
    "activated": "Activated",
    "deactivated": "Deactivated",
    "registered": "New"
  },
  "actions": {
    "scheduled": {
      "title": "Actions in progress?",
      "yes": "Yes",
      "no": "No",
      "error": "Undefined"
    }
  },
  "additionalMetadata": {
    "title": "Additional metadata",
    "username": "Username",
    "installationDate": "Installation date",
    "computerName": "Computer name",
    "licenseId": "License number: {value}",
    "options": {
      "title": "Options",
      "numericSoftware": {
        "1": "Remote terminal units: {value}",
        "2": "License expiry date: {value}"
      }
    }
  },
  "firmwareVersion": "Firmware version",
  "updateCertificate": "Update certificate",
  "updateState": {
    "activate": {
      "title": "Activate",
      "execute": "Activate application",
      "description": "Application {name} will be activated."
    },
    "deactivate": {
      "title": "Deactivate",
      "execute": "Deactivate application",
      "description": "Application {name} will be deactivated.",
      "warning": "A deactivated application does no longer benefits of automatic and manual certificate updates.",
      "error": "This application cannot be deactivated because it has an operation scheduled or running."
    }
  },
  "month": "{n} month | {n} months",
  "year": "{n} year | {n} years",
  "dateFormat": "YYYY/MM/DD hh:mm A",
  "empty": "No application found",
  "delete": {
    "execute": "Delete application",
    "description": "Application {name} will be deleted.",
    "warning": "The operations associated with the application will also be deleted.",
    "error": "This application cannot be deleted because it has an operation scheduled or running."
  },
  "description": {
    "certificateValidityDate": "Certificate validity date",
    "communicationProtocol": "Communication protocol",
    "configurationApplicationDate": "Configuration application date",
    "connectivity": "Connectivity",
    "firmwareVersion": "Firmware version",
    "firstCommissioningDate": "Date of the first commissioning",
    "gsmFrequencyBand": "GSM frequency band",
    "idCard": "Id card",
    "lastChange": "Last change",
    "lastConnection": "Last connection",
    "lastFirmwareUpdate": "Last firmware update",
    "lastRebootDate": "Last reboot Date",
    "mobileNetwork": "Mobile network",
    "model": "Model",
    "name": "Name",
    "serialNumber": "Serial number",
    "state": "State",
    "terminalName": "Terminal name",
    "title": "Description",
    "type": "Type",
    "windowsUsername": "Windows username"
  },
  "certificateForm": {
    "expirationDate": "Certificate expiration date",
    "certificateOrigin": "Origin of the certificate",
    "lastUpdate": "Last update of the certificate"
  },
  "operation": {
    "cancelAction": {
      "title": "Cancel operation",
      "confirm": {
        "title": "Are you sure you want to cancel this operation?",
        "description": "This operation will be cancelled"
      }
    },
    "updateAction": {
      "title": "Update operation"
    },
    "unitary": "Unitary",
    "campaign": "Campaign"
  },
  "back": "back"
}
